import { ApplicationInsights } from "@microsoft/applicationinsights-web";

if (!window.appInsights) {
    window.appInsights = new ApplicationInsights({
        config: {
            connectionString: process.env.REACT_APP_APPLICATION_INSIGHTS_CONNECTION_STRING,
            enableAutoRouteTracking: true,
            disableAjaxTracking: true,
            disableFetchTracking: true
        }
    });

    window.appInsights.loadAppInsights();
}

export const initializeAppInsights = () => {
    window.appInsights.trackPageView();
};

export const overrideConsoleError = () => {
    const logError = (function (oldErrorFunction) {
        return (message, ...data) => {
            oldErrorFunction(message, ...data);
            try {
                window.appInsights.trackException({
                    exception: message
                });
            } catch {
                // don't want to cause any weird errors to show up if we fail to track this execption
            }
        }
    })(window.console.error);

    window.console.error = logError;
};

export const appInsights = window.appInsights;